import { TaskHeaderCmp } from './task/header/task-header.cmp'
import { TaskHeaderButtonsCmp } from './task/header/buttons/task-header-buttons.cmp'
import { TaskListCmp } from './task/list/task-list.cmp'
import { TaskCmp } from './task/task.cmp'

export { TaskHeaderCmp } from './task/header/task-header.cmp'
export { TaskHeaderButtonsCmp } from './task/header/buttons/task-header-buttons.cmp'
export { TaskListCmp } from './task/list/task-list.cmp'
export { TaskCmp } from './task/task.cmp'
export const TASK_DIRECTIVES:Array<any> = [TaskHeaderCmp, TaskHeaderButtonsCmp, TaskListCmp, TaskCmp]


/** WEBPACK FOOTER **
 ** ./src/app/component/task.ts
 **/